import React, { useCallback } from 'react';
import { AuditorBranchesQueryParams } from '../hooks/useAuditorBranchesData';
import { Flex } from '@chakra-ui/react';
import { MerchantBranchSelector } from '../../../components/MerchantBranchSelector';

interface BranchFilterProps {
  onUpdateFilters: (key: keyof AuditorBranchesQueryParams, value: string | undefined) => void;
  queryParams?: AuditorBranchesQueryParams;
}

export const BranchFilters = (props: BranchFilterProps) => {
  const { queryParams, onUpdateFilters } = props;

  const handleUpdate = useCallback(onUpdateFilters, [onUpdateFilters])

  return (<>
    <Flex flexWrap="wrap" marginBottom="xl" width="full" justifyContent="end">
      <MerchantBranchSelector idMerchant={queryParams?.idMerchant} idBranch={queryParams?.idBranch} handleUpdate={handleUpdate} />
    </Flex>

  </>)
    ;
};
